import { Download } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { GqlFieldworkerPayment } from "~/__generated__";
import GaiaPageGridComponent from "~/modules/app/components/GaiaPageGridComponent";
import GaiaDataGrid from "~/modules/app/components/GaiaTable";
import { dateMonthFormatter, formatDateTime, formatKilometers, formatSeconds } from "~/modules/app/util/formatters";

type Props = {
    data: GqlFieldworkerPayment[];
    loading: boolean;
};

export default function PaidPayments({ data, loading }: Props) {
    const { t } = useTranslation("payments");

    return (
        <GaiaPageGridComponent>
            <GaiaDataGrid
                rows={data}
                columns={useMemo(
                    () => [
                        {
                            field: "period",
                            headerName: t("paidPayments.colPeriod"),
                            flex: 1,
                            valueGetter: (_, row) => dateMonthFormatter(new Date(row.period)),
                        },
                        {
                            field: "createdAt",
                            headerName: t("paidPayments.colCreatedAt"),
                            flex: 1,
                            valueGetter: (_, row) => formatDateTime(new Date(row.paymentDate)),
                        },
                        {
                            field: "scope",
                            headerName: t("paidPayments.colScope"),
                        },
                        {
                            field: "day",
                            headerName: t("paidPayments.colDay"),
                            valueGetter: (_, row) => formatSeconds(row.total.daySeconds),
                        },
                        {
                            field: "night",
                            headerName: t("paidPayments.colNight"),
                            valueGetter: (_, row) => formatSeconds(row.total.nightSeconds),
                        },
                        {
                            field: "distance",
                            headerName: t("paidPayments.colDistance"),
                            valueGetter: (_, row) => `${formatKilometers(row.total.travelDistanceMeters)} km`,
                        },
                        {
                            type: "actions",
                            field: "id",
                            renderCell: params => {
                                return (
                                    <IconButton color="primary" href={params.row.media.url} target="_blank">
                                        <Download />
                                    </IconButton>
                                );
                            },
                        },
                    ],
                    [t],
                )}
                loading={loading}
                rowCount={data.length}
            />
        </GaiaPageGridComponent>
    );
}
